import * as XLSX from 'xlsx';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Make sure to import Link
import axios from 'axios';
import { MdArrowDropDown } from "react-icons/md";
import excel from "../assests/images/excel img.png";
import Constant from "../Components/Utils/Constant";
import ReactPaginate from "react-paginate";
import UserSidebar from './UserSidebar';
import AffiliateUserEditform from './UserEditform';
import CreateUserPopup from './CreateUserPopup';
import { useDispatch, useSelector } from 'react-redux';
import { cuponRequest, subscriptionRequest } from '../Redux/reducer/DataReducer';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditModelUser from './EditModelUser';
import RefundPolicy from './RefundPolicy';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions'; 
import { X } from 'lucide-react';


// Footer Component integrated directly
const Footer = () => {
  const [showRefundPolicy, setShowRefundPolicy] = useState(false);
  const footerStyle = {
    backgroundColor: '#f8f9fa',
    padding: '20px 0',
    textAlign: 'center',
    borderTop: '1px solid #e7e7e7',
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    zIndex: 1000,
  };

  const linkStyle = {
    margin: '0 15px',
    color: '#007bff',
    textDecoration: 'none',
    fontWeight: 'bold',
  };

 return (
    <>
     
    <footer style={footerStyle}>
      <div className="container">
        <Link to="/AffiliateDashboard/privacy-policy" style={linkStyle}>Privacy Policy</Link> |
        <Link to="/AffiliateDashboard/terms-and-conditions" style={linkStyle}>Terms & Conditions</Link> |
       <Link onClick={() => setShowRefundPolicy(true)} style={linkStyle}>Refund Policy</Link>
      </div>
    </footer>


      {/* Refund Policy Modal */}
      {showRefundPolicy && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="flex justify-between items-center p-6 border-b">
              <h2 className="text-xl font-semibold text-gray-900">
                Refund Policy - "Texpidea Technologies Pvt. Ltd."
              </h2>
              <button
                onClick={() => setShowRefundPolicy(false)}
                className="p-1 hover:bg-gray-100 rounded-full transition-colors"
              >
                <X size={20} className="text-gray-500" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 space-y-4">
              <p className="text-sm text-gray-600 mb-4">
                <strong>Effective Date:</strong> 01/09/2025
              </p>

              <p className="text-gray-700">
                At Texpidea Technologies Pvt. Ltd., we strive to ensure customer satisfaction. 
                This Refund Policy explains how refunds are handled for purchases made through Texpidea Technologies Pvt. Ltd..
              </p>

              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">1. Eligibility for Refunds</h3>
                  <ul className="space-y-1 text-gray-700 ml-4">
                    <li>• Refunds may be considered only if there is a technical issue that prevents the use of the Service.</li>
                    <li>• To be eligible, users must contact our support team within 7 days of the purchase with valid proof.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">2. Non-Refundable Situations</h3>
                  <p className="text-gray-700 mb-2">Refunds will not be provided in cases where:</p>
                  <ul className="space-y-1 text-gray-700 ml-4">
                    <li>• The issue is due to user error or lack of device compatibility.</li>
                    <li>• The service has been used or partially consumed.</li>
                    <li>• Refund is requested beyond the 7-day window.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">3. Processing of Refunds</h3>
                  <p className="text-gray-700">
                    Approved refunds will be processed and credited to the original payment method within 7-10 business days.
                  </p>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="flex justify-end p-6 border-t bg-gray-50">
              <button
                onClick={() => setShowRefundPolicy(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};


export default function AffiliateUsers() {

  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [user, setUser] = useState([]);
  const [totalCount, setTotalCount] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const tableRef = React.createRef();
  const [showUserForm, setShowUserForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showBlockConfirmation, setShowBlockConfirmation] = useState(false);
  const [showRenewConfirmation, setShowRenewConfirmation] = useState(false);
  const [dropdownStates, setDropdownStates] = useState(Array(user.length).fill(false));
  const [data, setData] = useState([])
  const [userName, setUserName] = useState("");
  const [editPopup, setEditPopup] = useState(false)
  const subscriptionRes = useSelector(state => state?.DataReducer?.subscription)
  const cuponRes = useSelector(state => state?.DataReducer?.cupon)
  const dispatch = useDispatch()
  const highlightedId = useSelector(state => state.DataReducer.highlightedId);
  const resetHighlightedId = useSelector(state => state.DataReducer.resetHighlightedId);

  const [userToBlock, setUserToBlock] = useState(null);
  // State to manage the watermark popup visibility and user info
  const [showWatermarkConfirmation, setShowWatermarkConfirmation] = useState(false);
  const [userToChangeWatermark, setUserToChangeWatermark] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editData, setEditData] = useState(false)
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  console.log("subscriptionRes", subscriptionRes)
  // Function to handle option selection
  const handleOptionChange = (event, user) => {
    const selectedValue = event.target.value;
    if (selectedValue === 'renew') {
      handleUpdateUser(user);
    };
  }
  // State for confirmation popups
  const handleUpdateUser = (user) => {
    setSelectedUser(user);
    setShowUpdateForm(true);
  };
  const handleCloseUpdateForm = () => {
    setShowUpdateForm(false);
    setSelectedUser(null);
  };
  // block functionality
  const handleBlockConfirmation = (user) => {
    setUserToBlock(user);
    setShowBlockConfirmation(true);
  };

  const handleConfirmBlock = async () => {
    if (userToBlock) {
      try {
        const newBlockStatus = !userToBlock.block;

        const response = await axios.put(
          `${Constant.BASE_URL}/user/updatebyid`,
          { block: newBlockStatus, ...userToBlock }
        );

        console.log('Response:', response.data);

        if (response.status === 200) {
          setUser((prevAdmins) =>
            prevAdmins.map((item) =>
              item._id === userToBlock._id
                ? { ...item, block: newBlockStatus }
                : item
            )
          );

          const message = newBlockStatus ? 'Blocked' : 'Unblocked';
          toast.success(`User ${message} successfully!`);
        } else {
          toast.error('Failed to update user status.');
        }

        setShowBlockConfirmation(false);
        setUserToBlock(null);
      } catch (error) {
        console.error('Error blocking user:', error);
        toast.error('Failed to update user status.');
      }
    }
  };

  const handleCloseBlockConfirmation = () => {
    setShowBlockConfirmation(false);
    setUserToBlock(null);
  };

  // Function to handle the confirmation popup
  const handleWatermarkChange = (user) => {
    setUserToChangeWatermark(user);
    setShowWatermarkConfirmation(true);
  };

  // Function to close the watermark confirmation popup
  const handleCloseWatermarkConfirmation = () => {
    setShowWatermarkConfirmation(false);
    setUserToChangeWatermark(null);
  };

  // Function to confirm the watermark change
  const handleConfirmWatermarkChange = async () => {

    if (userToChangeWatermark) {
      try {
        const newWatermarkStatus = !userToChangeWatermark.watermark;

        const response = await axios.put(
          `${Constant.BASE_URL}/user/updatebyid`,
          { ...userToChangeWatermark, watermark: newWatermarkStatus }
        );
        console.log('Response:', response.data);
        if (response.status === 200) {
          setUser((prevUsers) =>
            prevUsers.map((item) =>
              item._id === userToChangeWatermark._id
                ? { ...item, watermark: newWatermarkStatus }
                : item
            )
          );

          const message = newWatermarkStatus ? 'OFF' : 'ON';
          toast.success(`Watermark turned ${message}!`);
        } else {
          toast.error('Failed to change watermark status.');
        }

        setShowWatermarkConfirmation(false);
        setUserToChangeWatermark(null);
      } catch (error) {
        console.error('Error updating watermark:', error);
        toast.error('Failed to change watermark status.');
      }
    }
  };

  useEffect(() => {
    const storedName = localStorage.getItem("name");

    const filterUsersByCreatedBy = (createdBy) => {
      console.log("mava", data.map((item, i) => (item.createdby)), data)

      return data.filter(item => item.createdby === createdBy);
    };

    const filteredData = filterUsersByCreatedBy(storedName);
    setUser(filteredData);
    console.log("Filtered Data:", filteredData);

    if (storedName) {
      setUserName(storedName);
    } else {
      setUserName("Unauthorized");
    }
  }, [data]);

  // select options toggle
  const toggleDropdown = (index) => {
    const updatedDropdownStates = [...dropdownStates];
    updatedDropdownStates[index] = !updatedDropdownStates[index];
    setDropdownStates(updatedDropdownStates);
  };

  // select filter dropdown
  const toggleDropdownfilter = () => {
    setIsDropdownOpenfilter(!isDropdownOpenfilter);
  };

  // pop up form create user
  const handleCreateUserClick = () => {
    setShowUserForm(true);
  };

  const handleClosePopup = () => {
    setShowUserForm(false);
  };

  // State for confirmation popups

  const handleConfirmation = (confirmationType) => {
    setDropdownStates(false);

    if (confirmationType === "delete") {
      setShowDeleteConfirmation(true);
    } else if (confirmationType === "block") {
      setShowBlockConfirmation(true);
    } else if (confirmationType === "renew") {
      setShowRenewConfirmation(true);
    }
  };

  const handleCloseConfirmation = () => {
    setShowDeleteConfirmation(false);
    setShowBlockConfirmation(false);
    setShowRenewConfirmation(false);
  };

  // Edit form pop up

  const handleEditUserClick = () => {
    setShowEditForm(true);
  };
  const handleCloseEdit = () => {
    setShowEditForm(false);
  };

  // excel sheet download
  const handleExportToExcel = () => {
    if (tableRef.current) {
      const ws = XLSX.utils.table_to_sheet(tableRef.current);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
      XLSX.writeFile(wb, 'tablexls.xlsx');
    }
  };

  // get api
  useEffect(() => {
    const storedName = localStorage.getItem("name");
    setUserName(storedName)
    const fetchUser = async () => {
      try {
        const response = await fetch(`${Constant.BASE_URL}/user/getByAffiliate`,
          {
            method: 'POST', // or 'PUT', depending on your server's endpoint configuration
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              createdBy: storedName,
              // Add any other parameters you need to send in the body
            }),
          });
        const data = await response.json();
        // setUser(data.admins);
        if (data && data.admins) {
          setData(data.admins);
          if (data.success) {
            setTotalCount(data.totalCount);
            setTotalPages(data.totalPages);
            dispatch(subscriptionRequest())
            dispatch(cuponRequest())
          }
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchUser();
  }, [showUserForm]);

  const handlePageClick = async ({ selected }) => {
    const newPageNumber = selected + 1;

    try {
      const response = await fetch(`${Constant.BASE_URL}/user/getByAffiliate?page=${newPageNumber}`, {
        method: 'POST', // or 'PUT', depending on your server's endpoint configuration
        headers: {
          'Content-Type': 'application/json',
          // Add any other headers if required
        },
        body: JSON.stringify({
          createdBy: userName,
          // Add any other parameters you need to send in the body
        }),
      });
      const data = await response.json();

      if (data && data.admins) {
        setData(data.admins);
        if (data.success) {
          setTotalCount(data.totalCount);
          setTotalPages(data.totalPages);
          setCurrentPage(newPageNumber); // Set the current page
        }
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };


  // delete api
  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${Constant.BASE_URL}/user/delete/${id}`
      );
      if (response.status === 200) {
        setData(prevUsers => prevUsers.filter(user => user._id !== id));
        setShowDeleteConfirmation(false);
        alert("User deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("Failed to delete user");
    }
  };

  return (
    <UserSidebar>
      <>
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="p-3 bg-grey-300 lg:p-3 xl:p-3 2xl:p-6" style={{ paddingBottom: '80px' }}>
          <div
            style={{ borderRadius: "0px 0px 11px 11px" }}
            className="bg-white h-[78.55vh]"
          >
            <div className="flex items-center px-4 py-3 bg-white lg:py-2 xl:py-3 2xl:py-3">
              <div className="flex-1">
                <div className="flex justify-between px-10 lg:w-full lg:px-1 ">
                  <div className="flex ">
                    <div
                      style={{
                        background:
                          "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                      }}
                      className="flex items-center justify-center px-2 bg-white rounded-sm cursor-pointer lg:w-fit 2xl:px-3 lg:py-1 xl:py-2 2xl:py-3"
                    >
                      <div className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">
                        {" "}
                        <p>Created Users : {totalCount}</p>
                      </div>
                    </div>


                  </div>
                </div>
              </div>

              

              {/* Third Box */}
              <div className="flex-1 ">
                <div className="flex justify-end">
                  <div
                    className="flex mx-5 border border-white rounded-md ">
                    <img onClick={handleExportToExcel} src={excel} alt='excel' className='cursor-pointer w-10  2xl:w-[80px] lg:w-[25px] xl:w-[35px]' />
                  </div>

                  <div
                    style={{
                      background:
                        "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                    }}
                    className="lg:w-fit px-2 2xl:px-3 cursor-pointer  flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] "
                  >
                    <div
                      onClick={handleCreateUserClick}
                      className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold"
                    >
                      {" "}
                      <p>Create User</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full">
              <div className="tablebodydata overflow-y-auto lg:h-[65vh] xl:h-[64vh] 2xl:h-[67vh] relative ">
                <table
                  ref={tableRef}
                  className=" divide-y divide-gray-200 table-hover table-bordered"
                  id="myTable"
                >
                  <thead className='bg-gray-100'>
                    <tr>
                      <th>Action</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>Email</th>
                      <th>Coupon Used</th>
                      <th>Key Status</th>
                      <th>Last Login</th>
                      <th>App Watermark</th>
                      <th>Created By</th>
                      <th>Key Expire On</th>
                      <th>Block Status</th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-200">
                    {user.map((user, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}
                        style={{ background: highlightedId === user._id ? "yellow" : "none" }}
                      >
                        <td>
                          <div className=' flex justify-center items-center 2xl:text-sm  text-center  border border-white border-opacity-60 bg-white bg-opacity-57 '>

                            <select
                              style={{
                                boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.25)',
                                borderRadius: '5px',

                              }}
                              className=" lg:w-[67px] xl:w-[78px] 2xl:w-[120px] 2xl:text-xl  py-1 text-center  outline-none  border border-white border-opacity-60 bg-white bg-opacity-57 "
                              onChange={(event) => handleOptionChange(event, user)}
                              value={selectedOption}
                            >
                              <option value="">Select</option>
                              <option value="renew">{user.subscriptionexpiry ? 'Renew Key' : 'add new subscription '}</option>
                            </select>
                          </div>
                        </td>
                        <td>{user.name}</td>
                        <td>{user.phone}</td>
                        <td>{user.email}</td>
                        <td>{user.cuponapplied}</td>
                        <td style={{ color: user.subscriptionexpiry ? 'red' : 'green' }}>{user.subscriptionexpiry ? "Expired" : "Active"}</td>
                        <td>lastlogin</td>
                        <td >

                          <form className="max-w-sm mx-auto flex justify-center">
                            <label htmlFor="watermark_select" className="sr-only">Watermark select</label>
                            <div className="relative flex items-center">

                              <p
                                className="block py-1 px-2 w-14 text-sm bg-white border border-white border-opacity-60 bg-white bg-opacity-57 bg-transparent appearance-none focus:outline-none focus:ring-0 peer"
                                style={{
                                  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.25)',
                                  borderRadius: '5px 5px 5px 5px',
                                }}>
                                {user.watermark ? 'OFF' : 'ON'}
                              </p>

                            </div>
                          </form>
                        </td>
                        <td>{user.createdby}</td>
                        <td>{user.subscription.split('T')[0]}</td>
                        <td className="py-4 px-6 whitespace-nowrap">
                          {user.block ? (
                            <span className="text-black">Blocked</span>
                          ) : (
                            <span className="text-green-600">Active</span>
                          )}
                        </td>
                        <div className="flex justify-center ">
                          {/* Delete Confirmation Popup */}
                          {showDeleteConfirmation && (
                            <div className="pop-delete">
                              <div className="flex items-center justify-center w-full">
                                <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                                  <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[450px] items-center justify-center">
                                    <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
                                      Do you Want to Delete ?
                                    </div>

                                    <hr className="p-2 mt-1" />
                                    <div className="flex flex-col py-5 justify-center items-center  lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                      <button
                                        type="button"
                                        onClick={() => setShowDeleteConfirmation(false)}
                                        className="flex-shrink-0 py-1 bg-white shadow-md text px-7 rounded-sm"
                                        style={{
                                          boxShadow:
                                            "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                        }}
                                      >
                                        No
                                      </button>
                                      <button
                                        onClick={() => handleDelete(user._id)}
                                        className="flex-shrink-0 py-1 mt-5 text-white text px-7 rounded-sm"
                                        style={{
                                          background:
                                            "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)",
                                        }}
                                      >
                                        Yes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* Block Confirmation Popup */}

                          {showBlockConfirmation && (
                            <div className="pop-delete">
                              <div className="flex items-center justify-center w-full">
                                <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                                  <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[450px] items-center justify-center">
                                    <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
                                      Do you want to {userToBlock?.block ? 'Unblock' : 'Block'}?
                                    </div>
                                    <hr className="p-2 mt-1" />
                                    <div className="flex flex-col py-5 justify-center items-center lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                      <button
                                        type="button"
                                        onClick={handleCloseBlockConfirmation}
                                        className="flex-shrink-0 py-1 bg-white shadow-md text px-7 rounded-sm"
                                        style={{
                                          boxShadow:
                                            '0px 4px 8px 0px rgba(0, 0, 0, 0.25)',
                                        }}
                                      >
                                        No
                                      </button>
                                      <button
                                        onClick={() => { handleConfirmBlock(user) }}
                                        className="flex-shrink-0 py-1 mt-5 text-white text px-7 rounded-sm"
                                        style={{
                                          background:
                                            'radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)',
                                        }}
                                      >
                                        Yes
                                      </button>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Watermark Confirmation Popup */}
                          {showWatermarkConfirmation && (
                            <div className="pop-delete">
                              <div className="flex items-center justify-center w-full">
                                <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                                  <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[450px] items-center justify-center">
                                    <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
                                      Do you want to turn {userToChangeWatermark?.watermark ? 'OFF' : 'ON'} the Watermark?
                                    </div>

                                    <hr className="p-2 mt-1" />
                                    <div className="flex flex-col py-5 justify-center items-center lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                      <button
                                        type="button"
                                        onClick={handleCloseWatermarkConfirmation}
                                        className="flex-shrink-0 py-1 bg-white shadow-md text px-7 rounded-sm"
                                        style={{
                                          boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.25)',
                                        }}
                                      >
                                        No
                                      </button>
                                      <button
                                        onClick={handleConfirmWatermarkChange}
                                        className="flex-shrink-0 py-1 mt-5 text-white text px-7 rounded-sm"
                                        style={{
                                          background: 'radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)',
                                        }}
                                      >
                                        Yes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* renew key  */}
                          {showRenewConfirmation && (
                            <div className="pop-delete">
                              <div className="flex items-center justify-center w-full">
                                <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                                  <div className="lg:w-[600px] xl:w-[280px] 2xl:w-[450px] items-center justify-center">
                                    <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
                                      Do you Want to Renew ?
                                    </div>

                                    <hr className="p-2 mt-1" />
                                    <div className="flex flex-col py-5 justify-center items-center  lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                      <button
                                        type="button"
                                        onClick={handleCloseConfirmation}
                                        className="flex-shrink-0 py-1 bg-white shadow-md text px-7 rounded-sm"
                                        style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                                      >
                                        No
                                      </button>
                                      <button
                                        type="submit"
                                        className="flex-shrink-0 py-1 mt-5 text-white text px-7 rounded-sm"
                                        style={{
                                          background: "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)",
                                        }}
                                      >
                                        Yes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div >
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>


            {/* Show  create user form  */}
            {showUserForm && <CreateUserPopup subscriptionRes={subscriptionRes} cuponRes={cuponRes} onClose={handleClosePopup} />}
            {showEditForm && <AffiliateUserEditform subscriptionRes={subscriptionRes} cuponRes={cuponRes} onClosed={handleCloseEdit} />}
            {showUpdateForm && (
              <EditModelUser user={selectedUser} subscriptionRes={subscriptionRes} cuponRes={cuponRes} onClose={handleCloseUpdateForm} editData={editData} setEditData={setEditData} />
            )}
          </div>
        </div>
        <Footer />
      </>
      {/* Pagination code*/}
      <div className="flex lg:px-4">
        <div className="w-full  flex  bg-white  bg-white shadow-md backdrop-blur-[5.7px]">
          <div className="w-full  flex  items-center fixed lg:bottom-5 xl:bottom-6 2xl:bottom-6 border-t lg:text-[10px] xl:text-[14px] 2xl:text-3xl lg:pt-1 xl:pt-1 2xl:pt-0">
            <div className="flex justify-start w-full xl:px-5 2xl:p-5">
              <p>
                Showing  {(currentPage - 1) * 1 + 1} to{" "}
                {Math.min(currentPage * 15)} of {totalCount} (Total User)
                entries
              </p>
            </div>

            {/* pagination code */}
            <div className="flex justify-start pr-2 text-blue-500 pagination xl:pr-5">
              <ReactPaginate
                previousLabel={""}
                nextLabel={""}
                breakLabel={"...."}
                pageCount={totalPages}
                marginPagesDisplayed={1}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                className="flex justify-start"
              />
            </div>
          </div>
        </div >
        {editPopup && <AffiliateUserEditform subscriptionRes={subscriptionRes} cuponRes={cuponRes} setEditPopup={setEditPopup} editPopup={editPopup} />}
      </div >
    </UserSidebar >
  )
}